import React, {useState} from 'react';
import * as Yup from 'yup';

import ModalTemplate from '../../../components/modal';
import {
  AppForm,
  AppFormField,
  AppFormSubmitButton,
  ErrorMessage,
} from '../../../components/forms';
import './styles.scss';
import {strings} from '../../../util/strings';
import {compose} from 'redux';
import {connect} from 'react-redux';
import Header2 from '../../../components/headers/header2';
import {Row} from '../../../components/layout';
import Icon from '../../../components/icon';
import {Icons} from '../../../util/icons';
import colors from '../../../util/colors';
import {patch} from '../../../api/api';
import {uriChangePassword} from '../../../api/endpoints';
import AppButton from '../../../components/app-button';
import * as fonts from '../../../util/fonts';

interface ChangePasswordProps {
  showModal: boolean;
  setShowModal(value: boolean): void;
  labels: typeof strings.pt.myProfile;
  loginLabels: typeof strings.pt.login;
  messageLabels: typeof strings.pt.messages;
  servicesLabels?: typeof strings.pt.services;
  user: any;
}

function ChangePasswordModal({
  showModal,
  setShowModal,
  labels = strings.pt.myProfile,
  messageLabels = strings.pt.messages,
  loginLabels = strings.pt.login,
  servicesLabels = strings.pt.services,
  user,
}: ChangePasswordProps) {
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [formikContext, setFormikContext] = useState();
  const [valid, setValid] = useState(false);
  const [viewPassword, setViewPassword] = useState(false);
  const [viewRepeatPassword, setViewRepeatPassword] = useState(false);
  const [oldPassword, setOldPassword] = useState(false);

  const featureName = 'Profile-ChangePassword';

  const handlePasswordIconClick = (type: string) => {
    if (type === 'repeat') {
      setViewRepeatPassword(!viewRepeatPassword);
    } else if (type === 'old') {
      setOldPassword(!oldPassword);
    } else {
      setViewPassword(!viewPassword);
    }
  };

  const validationSchema = Yup.object().shape({
    password: Yup.string().required(messageLabels?.requiredField),
    newPassword: Yup.string()
      .required(' ')
      .matches(
        new RegExp('(?=.*\\d)(?=.*[A-Z]).{8,}'),
        labels?.changePassword_passwordError
      )
      .label(''),
    repeatPassword: Yup.string()
      .required(' ')
      .oneOf([Yup.ref('newPassword')], messageLabels.passwordsDontMatch),
  });

  const submitError =
    (formikContext &&
      (formikContext as any).errors &&
      (formikContext as any).errors.newPassword) ||
    (formikContext &&
      (formikContext as any).errors &&
      (formikContext as any).errors.repeatPassword) ||
    '';

  const handleSubmit = async (values: any) => {
    setSubmitting(true);
    const changePasswordParms = {
      oldPassword: values.password,
      newPassword: values.newPassword,
    };
    try {
      await patch(uriChangePassword(), changePasswordParms, featureName).then(
        (resp: any) => {
          if (resp.result.status === 'Success') {
            setSuccess(true);
          } else {
            if (resp.result.status === 'InternalError') {
              (formikContext as any).setFieldError(
                'password',
                labels?.myProfile_oldPasswordError
              );
            } else {
              setShowError(true);
            }
            setSuccess(false);
          }
        }
      );
      //history.push('/register-completed');
    } catch (e: any) {
      setSuccess(false);
      setShowError(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="change-password-modal-content">
      <ModalTemplate
        show={showModal}
        onHide={() => setShowModal(false)}
        cross={true}
        hideFooter={true}
        className="card-details-modal">
        <AppForm
          className="change-password-modal-form-container"
          initialValues={{
            password: '',
            newPassword: '',
            repeatPassword: '',
          }}
          validationSchema={validationSchema}
          onChange={(values: any) => {}}
          onValidation={(valid) => setValid(valid)}
          onSubmit={(values) => handleSubmit(values)}>
          <Row style={{fontSize: '24px', fontWeight: 'bolder', marginTop: 0}}>
            {labels?.changePassword_title}
          </Row>
          {!success && (
            <div className="change-password-container">
              <Row style={{...fonts.M}}>{labels?.changePassword_underText}</Row>
              <Row className="change-password-modal">
                {labels?.changePassword_currentPasswordLabel}
              </Row>
              <Row className="account-data-row">
                <AppFormField
                  name="password"
                  type={oldPassword ? '' : 'password'}
                  passwordIcon={true}
                  pwdIconClass="change-pwd-eye"
                  className="repeat-password"
                  handlePasswordIconClick={() => handlePasswordIconClick('old')}
                  showPassword={oldPassword}
                  handleFormikContext={(formik) => {
                    if (
                      !!!formikContext ||
                      formik.errors !== (formikContext as any).errors
                    ) {
                      setFormikContext(formik);
                    }
                  }}
                  showErrorMessage={true}
                />
              </Row>
              <hr className="account-data-hr" />
              <Row className="change-password-modal">
                {labels?.changePassword_newPasswordLabel}
              </Row>
              <Row className="account-data-row">
                <AppFormField
                  name="newPassword"
                  type={viewPassword ? '' : 'password'}
                  passwordIcon={true}
                  pwdIconClass="change-pwd-eye"
                  className="repeat-password"
                  handlePasswordIconClick={() => handlePasswordIconClick('')}
                  showPassword={viewPassword}
                />
              </Row>
              <Row className="change-password-modal">
                {labels?.changePassword_confirmNewPasswordLabel}
              </Row>
              <Row className="account-data-row">
                <AppFormField
                  name="repeatPassword"
                  type={viewRepeatPassword ? '' : 'password'}
                  passwordIcon={true}
                  pwdIconClass="change-pwd-eye"
                  className="repeat-password"
                  handlePasswordIconClick={() =>
                    handlePasswordIconClick('repeat')
                  }
                  showPassword={viewRepeatPassword}
                />
              </Row>
              <Row className="app-center">
                <ErrorMessage visible error={submitError} />
              </Row>
              <Row>
                <AppFormSubmitButton
                  title={labels?.changePassword_button}
                  className="stepper-continue-button change-password-submit-button"
                  disabled={!valid || submitting}
                />
              </Row>
            </div>
          )}
          {showError && (
            <ModalTemplate
              type="error"
              show={showError}
              onHide={() => setShowError(false)}
              hideFooter={true}
              cross={true}>
              <p style={{color: colors.alertRed, fontWeight: 'bold'}}>
                {servicesLabels?.services_error}
              </p>{' '}
            </ModalTemplate>
          )}
          {success && (
            <div className="submitted-modal-container">
              <Icon
                name={Icons.SUCCESS}
                width={'40'}
                height={'60'}
                color={colors.green}
                changeViewbox
                viewBox={'0 0 24 24'}
              />
              <Row>{loginLabels.login_changePassword_pwdChanged}</Row>
              <Row className="submitted-modal-button-row">
                <AppFormSubmitButton
                  title="Ok"
                  className="stepper-continue-button"
                  variant="secondary"
                  onClick={() => {
                    setShowModal(false);
                  }}
                />
              </Row>
            </div>
          )}
        </AppForm>
      </ModalTemplate>
    </div>
  );
}

const mapStateToProps = ({strings, user}: any) => ({
  labels: strings.value.pt.myProfile,
  messageLabels: strings.value.pt.messages,
  loginLabels: strings.value.pt.login,
  servicesLabels: strings.value.pt.services,
  user: user.value,
});

export default compose(connect(mapStateToProps)(ChangePasswordModal));
